
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iIQbF", function(module, exports) {
/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $5spQU = parcelRequire("5spQU");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $3DxCm = parcelRequire("3DxCm");


var $lzcvT = parcelRequire("lzcvT");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3Am3T = parcelRequire("3Am3T");


var $NomII = parcelRequire("NomII");


var $bQm3c = parcelRequire("bQm3c");


var $7mpOv = parcelRequire("7mpOv");


var $9wGTI = parcelRequire("9wGTI");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");








var $7hpmn = parcelRequire("7hpmn");

const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #1868DB)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_y44v1hzw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y44v1hzw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_y44v1ax6",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y44v1ax6",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { children: children, pulseCount: t1, isInObjectSideBar: t2 } = t0;
    const pulseCount = t1 === undefined ? 0 : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    if (isReducedMotion) {
        let t3;
        if ($[0] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "contextual-pulse-none"
            }, children);
            $[0] = children;
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    switch(pulseCount){
        case 1:
            {
                const t3 = isInObjectSideBar && "_2rko1rr0";
                let t4;
                if ($[2] !== t3) {
                    t4 = (0, $gMc0m.default)([
                        "_2rkopb1k",
                        t3
                    ]);
                    $[2] = t3;
                    $[3] = t4;
                } else t4 = $[3];
                let t5;
                if ($[4] !== children || $[5] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($af25143620373faf$var$SinglePulse, {
                        "data-testid": "contextual-pulse-single",
                        className: t4
                    }, children);
                    $[4] = children;
                    $[5] = t4;
                    $[6] = t5;
                } else t5 = $[6];
                return t5;
            }
        case 2:
            {
                const t3 = isInObjectSideBar && "_2rko1rr0";
                let t4;
                if ($[7] !== t3) {
                    t4 = (0, $gMc0m.default)([
                        "_2rkopb1k",
                        t3
                    ]);
                    $[7] = t3;
                    $[8] = t4;
                } else t4 = $[8];
                let t5;
                if ($[9] !== children || $[10] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($af25143620373faf$var$DoublePulse, {
                        "data-testid": "contextual-pulse-double",
                        className: t4
                    }, children);
                    $[9] = children;
                    $[10] = t4;
                    $[11] = t5;
                } else t5 = $[11];
                return t5;
            }
    }
    let t3;
    if ($[12] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "contextual-pulse-none"
        }, children);
        $[12] = children;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $gMc0m.default)([
                    "_2rkopb1k",
                    isInObjectSideBar && "_2rko1rr0"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $gMc0m.default)([
                    "_2rkopb1k",
                    isInObjectSideBar && "_2rko1rr0"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};





















var $jSnXV = parcelRequire("jSnXV");


var $gz8ZY = parcelRequire("gz8ZY");

const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    {
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $42omo.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $42omo.useCallback)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer && isNav4Enabled ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer,
            isNav4Enabled
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $42omo.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else isNav4Enabled ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else isNav4Enabled ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};


var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["AIPresentationGeneration"] = "ai-presentation-generation";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}



var $i1vUz = parcelRequire("i1vUz");

const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const $ = (0, $frIzR.c)(7);
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: null
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
            };
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
            };
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    if (scrollY !== null && scrollY < 400) {
        let t0;
        if ($[3] !== queryError) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
                queryError: queryError
            };
            $[3] = queryError;
            $[4] = t0;
        } else t0 = $[4];
        return t0;
    }
    let t0;
    if ($[5] !== queryError) {
        t0 = {
            dynamicActionTarget: null,
            queryError: queryError
        };
        $[5] = queryError;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
        queryError: queryError
    };
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};












var $ivb8S = parcelRequire("ivb8S");


var $d282Z = parcelRequire("d282Z");





var $3J7nf = parcelRequire("3J7nf");




const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType)=>{
    const $ = (0, $frIzR.c)(11);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $42omo.useState)(0);
    const hasLoaded = (0, $42omo.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { aiButtonTour: t0 } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: isChangeboardingVisible } = t0;
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    let t1;
    let t2;
    if ($[0] !== dynamicSplitButtonLoading || $[1] !== isAdminHubAIEnabled || $[2] !== isChangeboardingVisible || $[3] !== onboardingStateData || $[4] !== onboardingStateLoading || $[5] !== setOnboardingState || $[6] !== showCatchupAsDefault) {
        t1 = ()=>{
            if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled && !isChangeboardingVisible) {
                hasLoaded.current = true;
                const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
                if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                    setOnboardingState({
                        key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                        value: "true"
                    });
                    setPulseCount(2);
                } else if (showCatchupAsDefault) setPulseCount(1);
            }
        };
        t2 = [
            dynamicSplitButtonLoading,
            onboardingStateData,
            onboardingStateLoading,
            setPulseCount,
            setOnboardingState,
            showCatchupAsDefault,
            isAdminHubAIEnabled,
            isChangeboardingVisible
        ];
        $[0] = dynamicSplitButtonLoading;
        $[1] = isAdminHubAIEnabled;
        $[2] = isChangeboardingVisible;
        $[3] = onboardingStateData;
        $[4] = onboardingStateLoading;
        $[5] = setOnboardingState;
        $[6] = showCatchupAsDefault;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[9] !== pulseCount) {
        t3 = {
            pulseCount: pulseCount
        };
        $[9] = pulseCount;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $42omo.useState)(0);
    const hasLoaded = (0, $42omo.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { aiButtonTour: { isVisible: isChangeboardingVisible } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $42omo.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled && !isChangeboardingVisible) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled,
        isChangeboardingVisible
    ]);
    return {
        pulseCount: pulseCount
    };
};












var $cgtv4 = parcelRequire("cgtv4");




var $1qfLF = parcelRequire("1qfLF");




var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");




var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3Mg7y = parcelRequire("3Mg7y");

const $e6e8ee54bcb9bd8a$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });



var $e4o8D = parcelRequire("e4o8D");

const $7b40fa145aa0c9d8$var$i18n = (0, $cgtv4.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $ecnYn.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'radius.small',
    transition: 'background 0.1s ease-out',
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-hovered, #CFE1FD)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-pressed, #8FB8F6)"
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { dynamicActionText: dynamicActionText, isDynamicActionSelected: t1, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: t2 } = t0;
    const isDynamicActionSelected = t1 === undefined ? false : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t3 = !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles;
    const t4 = isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = !renderServerPlaceholder;
    let t7;
    if ($[3] !== dynamicActionText || $[4] !== isDynamicActionSelected || $[5] !== isInObjectSideBar || $[6] !== onDynamicActionClick) {
        t7 = dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "right",
            exitDirection: "right",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                "data-vc": "ai-floating-dynamic-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                onClick: ()=>onDynamicActionClick?.(),
                xcss: [
                    $7b40fa145aa0c9d8$var$defaultPressableStyles,
                    isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                    isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles
                ]
            }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
            ]
        }));
        $[3] = dynamicActionText;
        $[4] = isDynamicActionSelected;
        $[5] = isInObjectSideBar;
        $[6] = onDynamicActionClick;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: t6,
            exitThenEnter: true
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== onMenuButtonClick) {
        t10 = ()=>onMenuButtonClick?.();
        $[13] = onMenuButtonClick;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = isInObjectSideBar ? "circle" : "default";
    let t12;
    if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, $e6e8ee54bcb9bd8a$export$2c6a5235f6e9fe39),
            label: t9,
            onClick: t10,
            appearance: "subtle",
            isSelected: isMenuOpen,
            shape: t11
        });
        $[15] = isMenuOpen;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: t5,
            grow: "hug",
            space: "space.050",
            alignBlock: "center"
        }, t8, t12);
        $[20] = t12;
        $[21] = t5;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), triggerProps, t13);
        $[24] = t13;
        $[25] = triggerProps;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, $e6e8ee54bcb9bd8a$export$2c6a5235f6e9fe39),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};














// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19it1gk9 _2rkopb1k _bfhkhp5a _16qs130s _1bsb1sum _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19it1gk9 _2rkopb1k _bfhkhp5a _16qs130s _1bsb1sum _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($44548221e1617185$var$PopupWrapper, {
            ...props,
            ref: ref,
            role: "dialog"
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = ref;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});

















var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $u9agA = parcelRequire("u9agA");


var $5nBzc = parcelRequire("5nBzc");


var $cUQMr = parcelRequire("cUQMr");


var $g5gZt = parcelRequire("g5gZt");


var $1yB28 = parcelRequire("1yB28");


var $9RVmI = parcelRequire("9RVmI");


var $kevJM = parcelRequire("kevJM");





var $jmjWc = parcelRequire("jmjWc");


const $79bb63da5aefe6b8$export$3002a651e376e263 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Al-1J",
    name: "AIPresentationModalWrapper",
    loader: async ()=>(await (parcelRequire("dLuIW"))).AIPresentationModalWrapperWithErrorBoundary
});



var $c8mrj = parcelRequire("c8mrj");


var $8aF6s = parcelRequire("8aF6s");











var $jln20 = parcelRequire("jln20");


var $4aiCO = parcelRequire("4aiCO");


var $UNr39 = parcelRequire("UNr39");


const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    aiPresentationGenerationMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.ai-presentation-generation",
        defaultMessage: "Rewrite as presentation"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, isLivePage: t1, setIsOpen: setIsOpen, setPopupState: setPopupState } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const isSidePanelOpen = t2 === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = typeof document !== "undefined" ? document.querySelector("div#content") : null;
        $[2] = t3;
    } else t3 = $[2];
    const content = (0, $42omo.useRef)(t3);
    let t4;
    if ($[3] !== contentId) {
        t4 = {
            contentId: contentId,
            content: content
        };
        $[3] = contentId;
        $[4] = t4;
    } else t4 = $[4];
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)(t4);
    let t5;
    if ($[5] !== contentId || $[6] !== contentType || $[7] !== createAnalyticsEvent || $[8] !== edition || $[9] !== footerCommentsCount || $[10] !== handleBulkIssueCreate || $[11] !== intl || $[12] !== isLivePage || $[13] !== isSidePanelOpen || $[14] !== setIsOpen || $[15] !== setPopupState || $[16] !== showModal || $[17] !== showWarningDialog || $[18] !== spaceKey || $[19] !== unresolvedInlineCommentsCount) {
        const menuItems = [
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
                showMenuItem: true,
                isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).AIPresentationGeneration,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.aiPresentationGenerationMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_presentation_generation"),
                isDisabled: false,
                beta: true,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
                label: intl.formatMessage((0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation"),
                isDisabled: false,
                beta: false,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    label: ""
                })
            }
        ];
        const sectionItems = [
            {
                key: "Summarize",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showSection: menuItems.some($790b3996dfce6541$var$_temp)
            },
            {
                key: "Create",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
                showSection: !isLivePage && menuItems.some($790b3996dfce6541$var$_temp2)
            }
        ];
        const onMenuItemSelection = (key)=>{
            let additionalAnalyticsAttributes = {};
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
                numPageCommentsSummarized: footerCommentsCount,
                numInlineCommentsSummarized: unresolvedInlineCommentsCount
            };
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: `aiActionsMenuItem-${key}`,
                    attributes: {
                        contentId: contentId,
                        edition: edition,
                        ...additionalAnalyticsAttributes,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation")) {
                if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
                else {
                    setIsOpen(false);
                    handleBulkIssueCreate();
                }
            } else if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).AIPresentationGeneration) {
                showModal((0, $79bb63da5aefe6b8$export$3002a651e376e263), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey
                });
                setIsOpen(false);
                setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
            } else setPopupState(key);
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            testId: "ai-uber-button-menu-group"
        }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
                key: section.key,
                title: section.label
            }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                    iconBefore: item_1.icon,
                    key: item_1.key,
                    isDisabled: item_1.isDisabled,
                    onClick: ()=>{
                        onMenuItemSelection(item_1.key);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                    spread: "space-between",
                    alignBlock: "center"
                }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
        $[5] = contentId;
        $[6] = contentType;
        $[7] = createAnalyticsEvent;
        $[8] = edition;
        $[9] = footerCommentsCount;
        $[10] = handleBulkIssueCreate;
        $[11] = intl;
        $[12] = isLivePage;
        $[13] = isSidePanelOpen;
        $[14] = setIsOpen;
        $[15] = setPopupState;
        $[16] = showModal;
        $[17] = showWarningDialog;
        $[18] = spaceKey;
        $[19] = unresolvedInlineCommentsCount;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).AIPresentationGeneration,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.aiPresentationGenerationMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_presentation_generation'),
            isDisabled: false,
            beta: true,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item_0)=>item_0.section === 'Create' && item_0.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
            else {
                setIsOpen(false);
                handleBulkIssueCreate();
            }
        } else if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).AIPresentationGeneration) {
            showModal((0, $79bb63da5aefe6b8$export$3002a651e376e263), {
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey
            });
            setIsOpen(false);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                iconBefore: item_1.icon,
                key: item_1.key,
                isDisabled: item_1.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item_1.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center"
            }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};
function $790b3996dfce6541$var$_temp(item) {
    return item.section === "Summarize" && item.showMenuItem;
}
function $790b3996dfce6541$var$_temp2(item_0) {
    return item_0.section === "Create" && item_0.showMenuItem;
}

















var $2Nwuj = parcelRequire("2Nwuj");







var $5kEnh = parcelRequire("5kEnh");





var $auvZ1 = parcelRequire("auvZ1");


var $9VC5k = parcelRequire("9VC5k");


var $auLW1 = parcelRequire("auLW1");


var $eN3MW = parcelRequire("eN3MW");


var $brrvF = parcelRequire("brrvF");






const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $8C5kA.default)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    let t2;
    if ($[0] !== adminLink || $[1] !== contentId || $[2] !== contentType || $[3] !== intl || $[4] !== isLivePage || $[5] !== lastModifiedDate || $[6] !== onClose || $[7] !== popupState || $[8] !== setIsOpen || $[9] !== setPopupState || $[10] !== source || $[11] !== spaceKey) {
        const formatOptInMessageValues = {
            a: $0eb3a6f6be084bf0$var$_temp,
            br: $0eb3a6f6be084bf0$var$_temp2
        };
        const renderContent = ()=>{
            switch(popupState){
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Header,
                        spaceKey: spaceKey
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: onClose,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate,
                        setIsOpen: onClose,
                        source: source,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $brrvF.QuickSummaryUpsell), null);
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5kEnh.default), {
                        source: "quickSummary",
                        product: "confluence",
                        isOrgAdmin: true,
                        headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                        adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                        adminLink: adminLink,
                        onAdminClose: ()=>setIsOpen(false)
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setPopupState: setPopupState,
                        setIsOpen: setIsOpen,
                        isLivePage: isLivePage
                    });
            }
        };
        let t3;
        if ($[13] !== popupState) {
            t3 = (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles;
            $[13] = popupState;
            $[14] = t3;
        } else t3 = $[14];
        let t4;
        if ($[15] !== t3) {
            t4 = [
                t3
            ];
            $[15] = t3;
            $[16] = t4;
        } else t4 = $[16];
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4
        }, renderContent());
        $[0] = adminLink;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = lastModifiedDate;
        $[6] = onClose;
        $[7] = popupState;
        $[8] = setIsOpen;
        $[9] = setPopupState;
        $[10] = source;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $8C5kA.default)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auLW1.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setIsOpen: onClose,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $brrvF.QuickSummaryUpsell), null);
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5kEnh.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});
function $0eb3a6f6be084bf0$var$_temp(s) {
    return (0, $9wGTI.fg)("dst-a11y__replace-anchor-with-link__confluence-ai2") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s);
}
function $0eb3a6f6be084bf0$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null);
}



const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).summarizeSectionLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).inlineCommentsMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).pageCatchupMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).AIPresentationGeneration]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).aiPresentationGenerationMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false })=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $42omo.useState)((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $83cf8da53844c2d7$export$7571cdd921b49cc0)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage);
    const { pulseCount: pulseCount } = (0, $874fd8abb2c90fe4$export$b938e63de8ec6cb1)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu; // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    const isEnabled = isAIFeatureEnabled && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $42omo.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    }, []);
    const onDynamicActionClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $42omo.useCallback)(()=>{
        if (isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && isAdminHubAIEnabled) setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu) return 0, $44548221e1617185$export$2593be7073434b2d;
        return 0, $NomII.CustomPopupContainer;
    };
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af25143620373faf$export$cd20eff28c3c2c7f), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, !isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_ai_upsell_rovo_button_changeover') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3DxCm.AIButton), {
                ...triggerProps,
                onClick: onMenuButtonClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7b40fa145aa0c9d8$export$c226a072142c15e9), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu,
                isInObjectSideBar: isInObjectSideBar
            }))
    }));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _94n5oahv _1pbyzo7u _t9ecjq3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props)))));
};
module.exports["AIFloatingContextMenu"] = $b3acdd5624bc36ae$export$71951c424ee8d4c2;

});

parcelRegister("dLuIW", function(module, exports) {

let $a0577f4a46861873$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0577f4a46861873$var$load("lUQAm"),
    $a0577f4a46861873$var$load("eUy1m"),
    $a0577f4a46861873$var$load("3yFw0"),
    $a0577f4a46861873$var$load("6wr18"),
    $a0577f4a46861873$var$load("66kde"),
    $a0577f4a46861873$var$load("ffEVr"),
    $a0577f4a46861873$var$load("Wowvf"),
    $a0577f4a46861873$var$load("hhss7"),
    $a0577f4a46861873$var$load("4g8hn")
]).then(()=>parcelRequire('l2PDp'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("c8mrj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $42omo.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};
module.exports["useBulkIssueCreate"] = $c8e282bfad3727e4$export$ddc739fc0aea988a;

});


//# sourceMappingURL=ObjectSidebarControl.da346f68.js.map
